import { req } from '../@api/request';

export default class PatternService {
  static savePattern = async (data: any) => {
    const result = await req.post(`/auction/pattern`, data);
    return result.data;
  };
  static getPatternResult = async (p_idx: number) => {
    const result = await req.get(`/auction/pattern/${p_idx}`);
    return result.data;
  };
  static list = async (
    p_idx: number | string,
    sort: string,
    limit: number,
    offset: number,
    pnuFilter: string,
    itemCategoryFilter: string,
    prcFilter: string,
  ) => {
    const result = await req.get(
      `/auction/pattern/${p_idx}/list?sort=${sort}&limit=${limit}&offset=${offset}&pnuFilter=${pnuFilter}&itemCategoryFilter=${itemCategoryFilter}&prcFilter=${prcFilter}
      `,
    );
    return result.data;
  };
  static recommendPattern = async (limit: number, offset: number) => {
    const result = await req.get(`/auction/pattern/list/recommend`);
    return result.data;
  };
  static patternListRecommend = async (limit: number, offset: number) => {
    const result = await req.get(
      `/auction/pattern/list/recommend?limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static saveMyPattern = async (p_idx: number, data: any) => {
    const result = await req.post(`/auction/pattern/${p_idx}`, data);
    return result.data;
  };
  static patternList = async (type: string, limit: number, offset: number) => {
    const result = await req.get(
      `/auction/pattern/list?type=${type}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static deleteMyPattern = async (data: any) => {
    const result = await req.delete(`/auction/pattern`, { data });
    return result.data;
  };
  static getPatternReport = async (p_idx: number) => {
    const result = await req.get(`/auction/pattern/result/${p_idx}`);
    return result.data;
  };
  static update = async (p_idx: number, data: any) => {
    const result = await req.patch(`/auction/pattern/${p_idx}`, data);
    return result.data;
  };
}
